export const supportedCultures = ['en-', 'de-', 'fr-', 'ja-', 'ru-', 'zh-', 'da-'];

export const defaultCulture = 'en-US';
